import createAction from 'Store/utils/createAction';
import {
  TRIP_INFORMATION_SET_KIDS,
  TRIP_INFORMATION_UPDATE_KID,
  TRIP_INFORMATION_RESET_KIDS,
  TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS,
} from './constants';

function setKids(kids: Array<any>): SetKidsAction {
  return createAction(TRIP_INFORMATION_SET_KIDS, {
    kids,
  });
}

function setKidsWithoutClearProposals(kids: Array<any>): SetKidsAction {
  return createAction(TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS, {
    kids,
  });
}

function resetKids() {
  return createAction(TRIP_INFORMATION_RESET_KIDS);
}

function updateKid(index: number, valuesToUpdate: UpdateKidPayload): UpdateKidAction {
  return createAction(TRIP_INFORMATION_UPDATE_KID, {
    index,
    valuesToUpdate,
  });
}

export { setKids, updateKid, resetKids, setKidsWithoutClearProposals };
